import { JsonPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { HighlightJsService } from 'angular2-highlight-js';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { unescape } from 'querystring';

@Component({
    selector: 'psm-json-editor',
    templateUrl: 'jsonEditor.component.html',
    styleUrls: ['jsonEditor.component.scss']
})

export class JsonEditorComponent implements AfterViewInit, OnChanges {
    public readonly language: string = 'json';

    private isAfterViewInit: boolean;
    private logger: Logger;
    public isJsonValid: boolean = true;
    public error: string;

    @ViewChild('codeEditor') public jsonTextAreaElement;
    private jsonTextArea: HTMLInputElement;

    @Input()
    public json: string;

    @Output()
    public jsonChanged = new EventEmitter<string>();

    constructor(
        private service: HighlightJsService,
        private jsonPipe: JsonPipe,
        private loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('JsonEditorComponent');
    }

    public ngAfterViewInit() {
        this.jsonTextArea = this.jsonTextAreaElement.nativeElement;
        this.service.highlight(this.jsonTextArea);
        this.getContent();
        this.jsonTextArea.addEventListener('blur', () => this.formatAndEmitChange());
        this.isAfterViewInit = true;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (!this.isAfterViewInit) { return; }
        this.getContent();
    }

    private formatConfigTextArea() {
        this.json = this.jsonTextArea.textContent.trim();
        this.checkValid();

        if (this.isJsonValid && this.json) {
            this.jsonTextArea.textContent = this.jsonPipe.transform(JSON.parse(this.json));
            this.service.highlight(this.jsonTextArea);
        } else if (this.isJsonValid) {
            this.jsonTextArea.textContent = undefined;
            this.service.highlight(this.jsonTextArea);
        }
    }

    private formatAndEmitChange() {
        this.formatConfigTextArea();
        this.jsonChanged.emit(JSON.parse(this.json));
    }

    private checkValid() {
        try {
            if (this.json) {
                JSON.parse(this.json);
                this.isJsonValid = true;
            } else {
                // Set the json as valid, we will just ensure it is set to undefined
                this.isJsonValid = true;
                this.json = undefined;
            }
        } catch (err) {
            this.error = err.message;
            this.isJsonValid = false;
        }
    }

    private getContent() {
        if (this.json) {
            this.jsonTextArea.textContent = this.jsonPipe.transform(this.json);
            this.formatConfigTextArea();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/jsonEditor/jsonEditor.component.ts